export default __webpack_public_path__ + "spotlight.518e9a07.svg";